export default Object.freeze({
    YES: 'Sim',
    NO: 'Não',
    CLOSE: 'Fechar',
    FILTER: 'Filtrar',
    CLEAR: 'Limpar',
    INFO: 'Info',
    OR: 'ou',
    AUTHORSHIP: 'Autoria de ',
    APP_ON_PLAY_STORE: 'Aplicativo na Play Store',
    APP_ON_APPLE_STORE: 'Aplicativo na Apple Store',
    CANCEL: 'Cancelar',
    CONFIRM_LOGOUT: 'Sair do aplicativo',
    ACTIVE_PRINCIPLES_NO_DATA: "Medicamento não encontrado.",
    SIGN_NO_DATA: "Sinal clínico não encontrado.",
    NO_DATA: 'Nenhuma informação encontrada',
    ADDENDA: 'Adendos',
    SEE_RESULTS: 'Ver resultados',
    SEE_DRUG: 'Ver medicamento',
    RESULTS: 'Resultados',
    CONTINUE: "Continuar",
    MY_DATA: 'Minha conta',
    BACK: 'Voltar',
    AWNSER_QUESTIONS: "Responder questionário",
    CATEGORY: 'Categoria',
    CATEGORIES: 'Categorias',
    TRENDS: 'Tendências',
    HIGHLIGHTS: 'Destaques',
    NEWS: 'Novidades',
    DETAILS: 'Detalhes',
    NO_NAME: 'Sem nome cadastrado',

    DOSES_BACK_BUTTON: 'Doses',
    PRODUCTS_BACK_BUTTON: 'Produtos',
    ACTIVE_PRINCIPLE: 'Princípios Ativos',
    ACTIVE_PRINCIPLE_SINGULAR: 'Princípio Ativo',
    ALLOWED_ANIMALS: 'Animais',
    ALLOWED_ANIMALS_APPLICATION: 'Aplicações permitidas em',
    CALCULATORS: 'Calculadoras',
    SEARCH_TEXT: 'Pesquisar',

    FOOD_PET_SIZES: 'Portes',
    FOOD_PET_AGES: 'Idades',
    FOOD_PET_BREEDS: 'Raças',
    FOOD_TYPE: 'Tipo de Alimento',
    FOOD_CLASSES: 'Indicações Terapêuticas',
    FEATURES: 'Características',
    foodPresentation: function (presentation) { return `Alimento ${presentation} disponível em:` },

    EMAIL_HEADER_LOGIN: 'Entrar com o e-mail',
    EMAIL_HEADER_ENTER_PASSWORD: 'Confirme sua senha',
    EMAIL_HEADER_CREATE_PASSWORD: 'Cadastrar nova senha',
    EMAIL_HEADER_CONFIRM_EMAIL: 'Confirme seu e-mail',
    EMAIL_BODY_LOGIN: 'Digite seu e-mail para continuar seu acesso.',
    EMAIL_INPUT_LABEL: 'Seu e-mail',
    EMAIL_INPUT_PASSWORD: 'Sua senha',
    EMAIL_INPUT_NEW_PASSWORD: "Nova senha",
    EMAIL_NEW_USER_NAME: 'Digite seu nome completo',
    EMAIL_INPUT_AGAIN_LABEL: 'Insira seu e-mail novamente',
    EMAIL_INPUT_AGAIN_PASSWORD: 'Insira a nova senha novamente',

    DOSES_TAB_SECTION_TITLE: 'Indicações',
    VETERINARY_PRODUCTS: 'Medicamentos Veterinários',
    HUMAN_PRODUCTS: 'Medicamentos Humanos',
    PRESENTATION: 'Apresentações',
    REFERENCES: 'Referências',
    INTERNAL_REFERENCES: 'Referências Vet Alfa',
    EXTERNAL_REFERENCES: 'Referências externas',
    EXTERNAL: 'Externas',
    SELECT_NAVIGATION: 'Selecione o tópico de interesse',
    WHY_WE_CHANGED_OUR_LOGIN: 'Por que mudamos nosso login?',
    LOGIN_EMAIL: 'Continuar com o E-mail',
    LOGIN_GOOGLE: 'Continuar com o Google',
    LOGIN_FACEBOOK: 'Continuar com o Facebook',
    LOGIN_APPLE: 'Continuar com a Apple',
    LOGIN_FOOTER_TEXT_1: 'Usando o Vet Alfa, você aceita os ',
    LOGIN_FOOTER_TEXT_2: ' e as ',
    USE_TERMS_TITLE: 'Termos de Uso',
    PRIVACY_POLICIES_TITLE: 'Políticas de Privacidade',
    SLOGAN: 'Suporte à Decisões Clínicas Baseado em Evidências.',

    DRUGS_BRANDS: "Marcas",
    NO_CONTENT: 'Nenhum resultado encontrado',
    SEARCH_OR_SUGGEST_CONTENT: 'Clique para buscar em todas categorias ou para sugerir um novo conteúdo.',
    SUGGEST_CONTENT: 'Clique em sugerir e colabore com a comunidade Vet Alfa.',
    SEARCH_ON_VET_ALFA: 'Buscar no Vet Alfa',
    SUGGEST_CONTENT_BTN: 'Sugerir novo conteúdo',

    QUESTIONS_FIRST_STEP: 'Conte-nos mais sobre você...',
    QUESTIONS_SECOND_STEP: 'Falta pouco!',
    QUESTIONS_THIRD_STEP: 'Ufa, chegamos na última pergunta',
    QUESTIONS_FIRST_TOPIC: 'Qual a sua relação com a medicina veterinária?',
    QUESTIONS_PROFESSIONAL: 'Profissional',
    QUESTIONS_STUDENT: 'Graduando',
    QUESTIONS_OTHERS: 'Outros',
    QUESTIONS_PROFESSIONAL_SECOND_TOPIC: 'Onde você fez sua graduação e quais são as suas formações acadêmicas adicionais?',
    QUESTIONS_STUDENT_SECOND_TOPIC: 'Onde você está estudando e qual a sua previsão de formatura?',
    QUESTIONS_GRADUATION_YEAR: 'Previsão de formatura',
    QUESTIONS_SCHOOL: 'Instituição de ensino',
    QUESTIONS_NIVELS: 'Formações acadêmicas',
    QUESTIONS_OTHERS_SECOND_TOPIC: 'Qual a sua ocupação?',
    QUESTIONS_OCUPATION: 'Digite sua ocupação.',
    QUESTIONS_THIRD_TOPIC: 'Quais são suas áreas de interesse?',
    QUESTIONS_CONFIRM: 'Salvar respostas',
    QUESTIONS_SELECT_PLACEHOLDER: 'Selecione',
    QUESTIONS_KEEP_AWNSERING: 'Continuar a responder',
    QUESTIONS_CLOSE_SAVE: 'Encerrar questionário',
    QUESTIONS_ASK_KEEP_AWNSERING: 'Deseja sair e encerrar o questionário?',

    REFERENCE_CARD_NAME: 'Nome',
    REFERENCE_CARD_YEAR: 'Ano',
    REFERENCE_CARD_MAGAZINE: 'Revista',
    REFERENCE_CARD_SOURCE: 'Fonte',
    REFERENCE_CARD_EVIDENCE_LEVEL: 'Nível de Evidência',
    REFERENCE_WITHOUT_APPLICATION: 'Não se aplica',
    REFERENCE_GUIDELINE: 'Guideline',
    REFERENCE_WITHOUT_APPLICATION_BOOK: 'livro',
    REFERENCE_CARD_SITE: 'Site',
    REFERENCE_MORE_INFO: 'Para mais informações',
    REFERENCES_KNOW_MORE: 'Saiba mais sobre…',
    REFERENCES_LEVELS: 'Níveis de Evidência',
    REFERENCES_KNOW_MORE_SITE: 'https://www.cebm.net/2016/05/ocebm-levels-of-evidence/',
    REFERENCES_WHAT_IS: 'O que são?',
    REFERENCES_WHAT_IS_EXPLANATION: 'Os “níveis de evidência” do CEBM foram produzidos pela primeira vez em 1998 para o Call On Based Evidence, para viabilizar o processo de encontrar evidências apropriadas e seus resultados explícitos. Revisamos os "níveis" à luz de novos conceitos e dados e gostaríamos de receber seus comentários.',
    USER_SECTION_LOGOUT: 'Sair do aplicativo',
    USER_SECTION_CONTACT_WHATSAPP: 'Entre em contato pelo whatsapp',
    USER_SECTION_CONTACT_US: 'Entre em contato conosco',
    USER_EXCLUSION: 'Excluir meus dados e usuário',
    USER_EXCLUSION_MESSAGE: `
    Ao confirmar a exclusão de seus dados e do seu usuário, todos os dados referentes aos seus acessos, cadastro e navegação em nossas plataformas serão excluídos; garantindo o seu direito de controlar seus dados e como eles são utilizados.
    Solicitamos que você só confirme a exclusão caso tenha certeza absoluta de que quer tomar esta ação. Esta ação é irreversível e não será possível restaurar seus dados após a conclusão.
    Em caso de confirmação da deleção processaremos sua solicitação em até 15 dias úteis.
    Após o período supracitado, você não conseguirá acessar os nossos serviços com conta referida e deverá criar um novo acesso caso queira utilizar nossos serviços.
    Solicitamos, por gentileza, que não efetue o login/acesso durante o período de 15 dias úteis com o mesmo usuário a ser deletado. Recomendamos, também, que você faça o logout e se desconecte de outros dispositivos conectados a este usuário/cadastro.
    Ao concluir sua solicitação iremos descontinuar o acesso desta conta em todos os dispositivos associados.
    Caso você tenha uma assinatura ativa, por favor faça o cancelamento da mesma na sua conta da Apple Store ou Play Store antes de prosseguir com esta ação. Caso contrário, iremos cancelar sua assinatura manualmente respeitando o prazo supracitado para a deleção dos seus dados (15 dias úteis), seguindo as políticas de cancelmento da Apple e Play Stores.
    `,
    USER_EXCLUSION_NO_ACTION: 'Não quero deletar',
    USER_EXCLUSION_YES_ACTION: 'Deletar dados',
    USER_EXCLUSION_CHECKBOX: 'Estou de acordo com as informações supracitadas e desejo prosseguir com a exclusão do meu usuário e de todos os meus dados.',

    OPEN_ON_APP_TEXT: "Acesso rápido e evidências a um toque de distância ao acessar pelo aplicativo.",
    OPEN_ON_APP_CONFIRM_TEXT: "Mudar para o aplicativo",
    NOT_NOW: "Agora não",

    TOPICS_MANAGEMENT_CLICK_TO_ADD: 'Clique para criar novo registro.',

    ITEMS_MODES_RECENTS: 'Acessados recentemente',
    ITEMS_MODES_SEARCH: 'Buscar',
    ALGORITHMS_TITLE: 'Algoritmos',
    DISEASES_TITLE: 'Doenças',

    PURCHASES: {
        "SUBSCRIPTION_TYPE": "Plano",
        "SUBSCRIPTION_TYPE_MONTHLY": "Mensal",
        "SUBSCRIPTION_TYPE_ANNUALLY": "Anual",

        "SUBSCRIPTION_START_TIME": "Início da assinatura",
        "SUBSCRIPTION_RENEW": "Data de renovação da assinatura",
        "SUBSCRIPTION_EXPIRATION": "Data de expiração da assinatura",

        "SUBSCRIPTION_STATE": "Status",

        "SUBSCRIPTION_STATE_UNSPECIFIED": "Não especificado",
        "SUBSCRIPTION_STATE_PENDING": "Assinatura Pendente",
        "SUBSCRIPTION_STATE_ACTIVE": "Assinatura Ativa",
        "SUBSCRIPTION_STATE_PAUSED": "Assinatura Pausada",
        "SUBSCRIPTION_STATE_IN_GRACE_PERIOD": "Assinatura no período de carência",
        "SUBSCRIPTION_STATE_ON_HOLD": "Assinatura Suspensa",
        "SUBSCRIPTION_STATE_CANCELED": "Assinatura Cancelada",
        "SUBSCRIPTION_STATE_EXPIRED": "Assinatura Expirada",
    },
    DRUGS_INTERACTIONS: 'Interações Medicamentosas',
    DRUGS_INTERACTIONS_DISCLAIMER_1: 'Todas as interações são classificadas conforme os níveis abaixo:',
    DRUGS_INTERACTIONS_DISCLAIMER_2: 'Se nenhuma interação for encontrada, isso não implica que não existam interações.',
    DRUGS_INTERACTIONS_DISCLAIMER_3: 'As interações farmacológicas listadas foram relatadas ou são hipotetizadas em pessoas ou animais e podem ser relevantes em pacientes veterinários.',
    DRUGS_INTERACTIONS_DISCLAIMER_4: 'Salvo contrário, o uso em conjunto não é necessariamente contraindicado. No entanto, avalie os perigos potenciais e faça um monitoramento adicional conforme necessário.',

    DDX_TITLE: 'Diagnósticos Diferenciais',
    DISCLAIMER: `Algoritmos, Calculadoras, Diagnósticos Diferenciais e Interações Medicamentosas não são "dispositivos médico-veterinários". Estas seções são de uso restrito a acadêmicos de medicina veterinária e veterinários.
    <br></br>
    É imperativo que os usuários verifiquem todos os resultados e entendam que o cuidado e tratamento realizado em seus pacientes são integralmente de sua responsabilidade.
    `,

    FAKE_DOORS_ALGORITHMS: '<b class="primary--text">Algoritmos</b><br><br>É com grande entusiasmo que anunciamos a chegada dos <b>primeiros algoritmos veterinários interativos do mundo</b>.<br><br>Obtenha suporte clínico, passo a passo, a partir da nossa lista de fluxogramas interativos de diagnóstico, manejo e tratamento.<br><br>Esta funcionalidade <b>estará disponível a partir de 15 de Março</b>. Gostou?',
    FAKE_DOORS_DISEASES: '<b class="primary--text">Doenças</b><br><br>Temos uma novidade incrível para compartilhar com você!<br> Tenha acesso a <b>informações detalhadas sobre as mais diversas doenças que afetam cães e gatos</b>.<br><br> Agora você poderá contar com conteúdos completos e atualizados para te oferecer o melhor suporte clínico baseado em evidências.<br><br>Esta funcionalidade <b>estará disponível a partir de Abril</b>. Gostou?',
    FAKE_DOOR_YES: 'Gostei',
    FAKE_DOOR_NO: 'Não gostei'
});